import { Box } from '@mui/material';
import { PanelField } from '@/UI/PanelField/PanelField';
import type { PropsWithChildren } from 'react';

type LayerPropertyPanelFieldProps = PropsWithChildren<{
  label?: string;
}>;
export function LayerPropertyPanelField({ label, children }: LayerPropertyPanelFieldProps) {
  return (
    <Box sx={{ px: 2 }}>
      <PanelField label={label} labelGap={0}>
        {children}
      </PanelField>
    </Box>
  );
}
